import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HubspotForm from './HubSpotForm';
import Seo from './Seo';

function Contact({ source }) {
    const isInvestor = source === 'investor';

    return (
        <Container className="text-center text-white d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
            <Seo
                title="Contact — Qcoda | AI Engineering Governance"
                description="Talk to the Qcoda team about early access. Built into your existing PM and SDLC workflow — on your hardware, with your models."
                path="/contact"
            />
            <Row className="justify-content-center">
                <Col md={8} lg={6} className="p-5 rounded-4 text-start" style={{ backgroundColor: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
                    <h1 className="h2 mb-4 fw-bold text-center">Let's Talk</h1>
                    <p className="lead mb-4" style={{ lineHeight: '1.8' }}>
                        {isInvestor
                            ? "We'd love to share more about what we're building and where we're headed. Tell us a bit about yourself and we'll be in touch."
                            : "Select teams are already building with Qcoda in early access. If your team writes specs before you write code — or wishes you did — let's talk."
                        }
                    </p>
                    <p className="lead m-0 mb-4" style={{ lineHeight: '1.8' }}>
                        You can also reach us at <a href="mailto:hello@qcoda.com" className="text-white fw-bold text-decoration-underline underline-offset-4">hello@qcoda.com</a>
                    </p>

                    <div className="form-contact">
                        <HubspotForm
                            portalId='245090272'
                            formId='02f60fbd-6612-4d7b-a39d-4aa916411e96'
                            pageName={isInvestor ? 'Investor Contact' : 'Contact'}
                            submitLabel="Send"
                            successMessage="Thanks — your message is in. We'll be in touch."
                            fields={[
                                { name: 'firstname', label: 'First name', type: 'text', required: true },
                                { name: 'lastname', label: 'Last name', type: 'text', required: true },
                                { name: 'email', label: 'Email', type: 'email', required: true },
                                { name: 'message', label: 'Message', type: 'textarea', rows: 5, required: true },
                            ]}
                        />
                    </div>

                </Col>
            </Row>
        </Container>
    );
}

export default Contact;
